import { UserInfo } from 'src/app/interfaces';
import {
  ManageUserInfosData,
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import {
  manageMemberTableHead,
  manageUserInfosTableRowData,
  userInfosManageTableCellAttributes,
} from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class ManageUserInfosTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: ManageUserInfosData) {}

  public getTableHeadData(): TableHeadData[] {
    return manageMemberTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return userInfosManageTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return tableComponentStyles.members;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.users.map((user: UserInfo, id: number) => manageUserInfosTableRowData(id, user));
  }
}
